import React from 'react';

export default function KPIProgressBar({ value }) {
  const cappedValue = Math.min(Math.max(value, 0), 1);
  const percentage = cappedValue * 100;
  let bgColor = 'bg-green-500';
  if (percentage < 33) bgColor = 'bg-red-500';
  else if (percentage < 66) bgColor = 'bg-yellow-500';
  return (
    <div className="w-full bg-gray-200 rounded-full h-2">
      <div className={`${bgColor} h-2 rounded-full transition-all duration-300`} style={{ width: `${percentage}%` }} />
    </div>
  );
}
